"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeCrawler = void 0;
var product_category_relations_1 = require("../static/product-category-relations");
var TypeCrawler = /** @class */ (function () {
    function TypeCrawler() {
    }
    /**
     * Main method to crawl taxonomy relation
     */
    TypeCrawler.crawl = function (ref, term, mode, includeFirst) {
        if (mode === void 0) { mode = 'all'; }
        if (includeFirst === void 0) { includeFirst = true; }
        var stack = includeFirst ? [term] : [];
        this.staged = ref;
        var parents = null;
        var children = null;
        switch (mode) {
            case 'parents':
                parents = this.crawlParents(term);
                break;
            case 'children':
                children = this.crawlChildren(term);
                break;
            default:
                parents = this.crawlParents(term);
                children = this.crawlChildren(term);
        }
        if (parents) {
            stack.push.apply(stack, parents);
        }
        if (children) {
            stack.push.apply(stack, children);
        }
        return this.removeDuplicates(stack);
    };
    TypeCrawler.crawlChildren = function (term, stack) {
        if (stack === void 0) { stack = []; }
        if (!term) {
            return stack;
        }
        var response = this.findObject(term, { obj: this.staged, parent: null });
        if (response) {
            for (var child in response.obj) {
                if (response.obj.hasOwnProperty(child)) {
                    stack.push(child);
                    var results = this.crawlChildren(child, stack);
                    if (results) {
                        stack.push.apply(stack, results);
                    }
                }
            }
            return this.removeDuplicates(stack);
        }
        return null;
    };
    /**
     * Recursively gets the parents of a term
     */
    TypeCrawler.crawlParents = function (term, stack) {
        if (stack === void 0) { stack = []; }
        if (!term) {
            return stack;
        }
        // get the object with the selected term and the parent key it came from
        var response = this.findObject(term, { obj: this.staged, parent: null });
        if (response) {
            // console.log(response);
            if (response.parent) {
                stack.push(response.parent);
            }
            return this.crawlParents(response.parent, stack);
        }
        else {
            return null;
        }
    };
    /**
     * Returns the object and the parent it belongs to
     */
    TypeCrawler.findObject = function (term, crawl) {
        if (crawl.obj.hasOwnProperty(term)) {
            return {
                obj: crawl.obj[term],
                parent: crawl.parent
            };
        }
        for (var key in crawl.obj) {
            if (crawl.obj.hasOwnProperty(key)) {
                var result = this.findObject(term, {
                    obj: crawl.obj[key],
                    parent: key
                });
                if (result) {
                    return result;
                }
            }
        }
        return null;
    };
    TypeCrawler.removeDuplicates = function (types) {
        return types.reduce(function (accumlator, element) {
            var index = accumlator.findIndex(function (ref) { return ref === element; });
            if (!accumlator[index]) {
                accumlator.push(element);
            }
            return accumlator;
        }, []);
    };
    TypeCrawler.staged = product_category_relations_1.PRODUCT_CATEGORY_RELATIONS;
    return TypeCrawler;
}());
exports.TypeCrawler = TypeCrawler;
